// 选择车系车型
<template>
    <div>
        <van-cell-group>
            <van-cell title="车系" :value="series_name" is-link @click="showSeries" />
            <van-cell title="车型" :value="model_name" is-link @click="showModel" />
        </van-cell-group>
        <van-popup
            v-model="show_series"
            position="bottom"
            :style="{ height: '80%' }">
            <div v-if="layer==0">
                <van-grid :column-num="12" >
                    <van-grid-item
                        v-for="it in pys"
                        :key="it.i"
                        :text="it.n"
                        @click="pickpy(it)"/>
                </van-grid>
                <van-loading vertical v-if="loading" />
                <van-tree-select
                    :items="items"
                    :main-active-index.sync="index"
                    @click-nav="pickLeft"
                    @click-item="pickRight"/>
            </div>
            <van-list v-if="layer==1">
                <van-cell v-for="item in series" :key="item.i" :title="item.text" @click="pickSeries(item)"/>
            </van-list>
        </van-popup>
        <van-popup
            v-model="show_model"
            position="bottom"
            :style="{ height: '80%' }">
            <van-loading vertical v-if="loading" />
            <van-list>
                <van-cell v-for="item in models" :key="item.i" :title="item.text" @click="pickModel(item)"/>
            </van-list>
        </van-popup>
    </div>

</template>

<script>
import { 
    Popup,
    Cell, 
    CellGroup,
    TreeSelect,
    Grid, 
    GridItem,
    Loading,
    List } from 'vant'
import { CarCategoryApi, CarCategoryChildrenApi } from '@/api/base'
export default {
    name: 'SelSeries',
    components: {
        [Popup.name]: Popup,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [TreeSelect.name]: TreeSelect,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [List.name]: List,
        [Loading.name]: Loading
    },
    data() {
        return {
            loading: false,
            index: 0,
            data: [], // 所有数据
            layer: 0, // 层 0: 到品牌，1: 到型号
            py: null, // 选中拼音
            pys: [],  // 拼音导航
            series: [],
            models: [], // 型号
            leftitem: null, // 选中拼音树
            rightitem: null,
            show_series: false,
            show_model: false,
            series_name: '',
            model_name: '',
            model: null,
            items: []   // 选择部分
        }
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            that.axios.get(CarCategoryApi).then((ret) => {
                that.loading = false
                that.py = ret[0]
                that.pys = ret.map(it => {
                    return {
                        i: it.i,
                        n: it.n
                    }
                })
                that.data = ret // 所有数据
                that.items = that.getPYChildren(that.data, that.py)
            })
        },
        getPYChildren(list, p) {
            const parent = list.filter(it=>it.i === p.i)[0]
            const result = parent.c.map(it => {
                return {
                    i: it.i,
                    text: it.n,
                    children: it.c.map(itm => {
                        return {
                            i: itm.i,
                            text: itm.n,
                            item: itm
                        }
                    })
                }
            })
            this.leftitem = result[0]
            if (result[0].children.length > 0) {
                this.rightitem = result[0].children[0]
            }
            return result
        },
        pickpy(p) {
            this.py = p
            this.items = this.getPYChildren(this.data, p)
        },
        pickLeft(idx) {
            this.leftitem = this.items[idx]
            if (this.layer == 0) {
                if (this.leftitem.children != null && this.leftitem.children.length > 0) {
                    this.rightitem = this.leftitem.children[0]
                }
            } else {
                this.layer = 0
                this.model = this.leftitem.i
                this.series_name = this.leftitem.text
                this.show_series = false
            }
            
        },
        pickRight(itm) {
            this.layer = 1
            this.series = itm.item.c.map(it => {
                return {
                    i: it.i,
                    text: it.n
                }
            })
        },
        showSeries() {
            this.layer = 0
            this.show_series = true
            this.show_model = false
            this.series_name = ''
            this.model_name = ''
            this.model = null
            this.getData()
        },
        showModel() {
            if (this.model != null) {
                // 已经有了车系
                this.show_model = true
                this.show_series = false
                var that = this
                that.axios.get(CarCategoryChildrenApi, { params: { p: this.model }}).then((ret) => {
                    this.models = ret
                })
            } else {
                // 尚未选择车系
                this.show_series = true
                this.getData()
            }
        },
        pickSeries(item) {
            this.model = item.i
            this.series_name = item.text
            this.show_series = false
            this.$emit('pick', {id: item.i, name: item.text})
        },
        pickModel(item) {
            this.model = item.i
            this.model_name = item.text
            this.show_model = false
            this.$emit('pick', {id: item.i, name: item.text})
        }
    }
}
</script>